import { IAppState } from '../../redux';
import { EFairPlayErrorCode } from '../../redux/reducers';

export function selectFairPlayErrorCode(state: IAppState): EFairPlayErrorCode | null {
  const {
    fairPlay: { errorCode },
  } = state;

  return errorCode;
}
